"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var recordSheets_config_1 = __importDefault(require("./recordSheets.config"));
var RecordSheetsService = /** @class */ (function (_super) {
    __extends(RecordSheetsService, _super);
    function RecordSheetsService(BASE_URL, FUNCTIONS_KEY) {
        var _this = _super.call(this, BASE_URL, FUNCTIONS_KEY) || this;
        // Record
        _this.getAllAvailableRecordByUser = function (userId) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.axios.get("/api/v2/user/".concat(userId, "/prestaciones"))];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        }); };
        _this.getCompleteRecordWithTd = function (prestacionId, userId) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.axios.get("/api/v2/user/".concat(userId, "/prestacionConIT/").concat(prestacionId))];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        }); };
        _this.getCompleteRecordWithoutTd = function (prestacionId, userId) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.axios.get("/api/v2/user/".concat(userId, "/prestacionSinIT/").concat(prestacionId))];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        }); };
        _this.getCompleteRecordCata = function (prestacionId, userId) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.axios.get("/api/v2/user/".concat(userId, "/prestacionCATA/").concat(prestacionId))];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        }); };
        _this.getCompleteRecordOficio = function (prestacionId, userId) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.axios.get("/api/v2/user/".concat(userId, "/prestacionOficio/").concat(prestacionId))];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        }); };
        //ManagementDocument
        _this.getManagementDocument = function (userId, prestacionId, documentoId) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.axios.get("/api/v2/user/".concat(userId, "/prestacion/").concat(prestacionId, "/documento/").concat(documentoId))];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        }); };
        _this.getAllManagementDocument = function (userId, prestacionId) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.axios.get("/api/v2/user/".concat(userId, "/prestacion/").concat(prestacionId, "/documentos"))];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        }); };
        // Management - Administration
        _this.getAllAdministrationRecord = function (userId, prestacionId) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.axios.get("/api/v2/user/".concat(userId, "/prestacion/").concat(prestacionId, "/administracion"))];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        }); };
        // ConfirmationPart = ParteConfirmacion
        _this.getConfirmationPart = function (userId, prestacionId, parteId) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.axios.get("/api/v2/user/".concat(userId, "/prestacion/").concat(prestacionId, "/parteconfirmacion/").concat(parteId))];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        }); };
        // DischargeLeavePart = ParteAltaBaja
        _this.getDischargeLeavePart = function (userId, prestacionId, parteId) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.axios.get("/api/v2/user/".concat(userId, "/prestacion/").concat(prestacionId, "/partealtabaja/").concat(parteId))];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        }); };
        // WithoutLeavePart = ParteSinBaja
        _this.getWithoutLeavePart = function (userId, prestacionId, parteId) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.axios.get("/api/v2/user/".concat(userId, "/prestacion/").concat(prestacionId, "/partesinbaja/").concat(parteId))];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        }); };
        // WorkerEnvironment
        _this.getWorkerEnvironment = function (userId, prestacionId, entornolaboralId) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.axios.get("/api/v2/user/".concat(userId, "/prestacion/").concat(prestacionId, "/entornolaboral/").concat(entornolaboralId))];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        }); };
        //SummaryCATA = ResumenCATA
        _this.getSummaryCata = function (id) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.axios.get("/api/v1/get-summary-cata?Id=".concat(id))];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        }); };
        // Management - Economics
        _this.getAllEconomicRecord = function (userId, prestacionId) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.axios.get("/api/v2/user/".concat(userId, "/prestacion/").concat(prestacionId, "/economicos"))];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        }); };
        //TSDPayment = TSDPago
        _this.getTSDPayment = function (id) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.axios.get("/api/v1/get-tsd-payment?Id=".concat(id))];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        }); };
        // Compensacion sld
        _this.getCompensationSld = function (userId, prestacionId, compensacionSLDId) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.axios.get("/api/v2/user/".concat(userId, "/prestacion/").concat(prestacionId, "/economico/compensacionSLD/").concat(compensacionSLDId))];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        }); };
        // Recovery = Recobro
        _this.getRecovery = function (userId, prestacionId, recobroId) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.axios.get("/api/v2/user/".concat(userId, "/prestacion/").concat(prestacionId, "/economico/recobro/").concat(recobroId))];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        }); };
        // ImsSummary = IMSResumen
        _this.getImsSummary = function (userId, prestacionId, resumenIMSId) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.axios.get("/api/v2/user/".concat(userId, "/prestacion/").concat(prestacionId, "/economico/resumenIMS/").concat(resumenIMSId))];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        }); };
        // GeneralExpenses = GastosGenerales
        // getGeneralExpenses = async (id: guid) => {
        //   return await this.axios.get(`/api/v1/get-general-expenses?Id=${id}`);
        // };
        //Gastos Asistenciales
        _this.getCareExpenses = function (userId, prestacionId, gastoAsistencialId) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.axios.get("api/v2/user/".concat(userId, "/prestacion/").concat(prestacionId, "/economico/gasto/gastoAsistencial/").concat(gastoAsistencialId))];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        }); };
        // pago Directo
        _this.getDirectPayment = function (userId, prestacionId, pagoDirectoId) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.axios.get("api/v2/user/".concat(userId, "/prestacion/").concat(prestacionId, "/economico/pagoDirecto/").concat(pagoDirectoId))];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        }); };
        //SpecialBenefitsCommission = ComisionPrestacionesEspeciales
        _this.getSpecialBenefitsCommission = function (userId, prestacionId, comisionPrestacionEspecialId) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.axios.get("api/v2/user/".concat(userId, "/prestacion/").concat(prestacionId, "/economico/comisionPrestacionEspecial/").concat(comisionPrestacionEspecialId))];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        }); };
        // RegulatoryBaseCATA = BaseReguladoraCata
        _this.getRegulatoryBaseCATA = function (userId, prestacionId, baseReguladoraCATAId) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.axios.get("/api/v2/user/".concat(userId, "/prestacion/").concat(prestacionId, "/economico/BaseCotizacionCATA/").concat(baseReguladoraCATAId))];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        }); };
        // RegulatoryBase = BaseReguladora
        _this.getRegulatoryBase = function (userId, prestacionId, baseReguladoraId) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.axios.get("/api/v2/user/".concat(userId, "/prestacion/").concat(prestacionId, "/economico/baseReguladora/").concat(baseReguladoraId))];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        }); };
        //Gastos Juridico
        _this.getLegalExpenses = function (userId, prestacionId, gastoJuridicoId) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.axios.get("/api/v2/user/".concat(userId, "/prestacion/").concat(prestacionId, "/economico/gasto/gastoJuridico/").concat(gastoJuridicoId))];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        }); };
        // NavisionInvoiceExpensive = Gastos factura
        _this.getNavisionInvoiceExpensive = function (id) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.axios.get("/api/v1/get-navision-invoice-expense?Id=".concat(id))];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        }); };
        // TransportationExpense = Gastos transporte
        _this.getTransportationExpense = function (userId, prestacionId, gastoTransporteId) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.axios.get("/api/v2/user/".concat(userId, "/prestacion/").concat(prestacionId, "/economico/gasto/gastoTransporte/").concat(gastoTransporteId))];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        }); };
        // PharmacyExpense = Gastos farmacéuticos
        _this.getPharmacyExpense = function (userId, prestacionId, gastoFarmaciaId) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.axios.get("/api/v2/user/".concat(userId, "/prestacion/").concat(prestacionId, "/economico/gasto/gastoFarmacia/").concat(gastoFarmaciaId))];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        }); };
        //REPOSICION ORTOPROTESICA
        _this.getOrthoprostheticReplacement = function (userId, prestacionId, reposicionOrtoprotesicaId) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.axios.get("/api/v2/user/".concat(userId, "/prestacion/").concat(prestacionId, "/economico/reposicionOrtoprotesica/").concat(reposicionOrtoprotesicaId))];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        }); };
        //REGULARIZACION
        _this.getRegularization = function (userId, prestacionId, regularizacionId) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.axios.get("/api/v2/user/".concat(userId, "/prestacion/").concat(prestacionId, "/economico/regularizacion/").concat(regularizacionId))];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        }); };
        // BaseQuoteApp = Base cotización
        _this.getBaseQuoteApp = function (id) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.axios.get("/api/v1/get-base-quote-app?Id=".concat(id))];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        }); };
        // Extinction =
        _this.getExtinction = function (id) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.axios.get("/api/v1/get-extinction?Id=".concat(id))];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        }); };
        // Record visits
        //
        _this.getAllHealthcareInformation = function (id) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.axios.get("/api/v1/get-all-healthcare-information?Id=".concat(id))];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        }); };
        // llamada contador componente asistencial
        _this.getCareComponentCount = function (userId, prestacionId) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.axios.get("/api/v2/user/".concat(userId, "/prestacion/").concat(prestacionId, "/asistencial/count"))];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        }); };
        // Hospitalization = Hospitalización por idEpisode
        _this.getHospitalization = function (userId, prestacionId, episodioId) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.axios.get("/api/v2/user/".concat(userId, "/prestacion/").concat(prestacionId, "/asistencial/episodios/hospitalizacion/").concat(episodioId))];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        }); };
        // OperationRoom = Quirófano
        _this.getOperationRoom = function (userId, prestacionId, episodioId) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.axios.get("/api/v2/user/".concat(userId, "/prestacion/").concat(prestacionId, "/asistencial/episodios/quirofano/").concat(episodioId))];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        }); };
        // Rehabilitation
        _this.getRehabilitation = function (userId, prestacionId, episodioId) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.axios.get("/api/v2/user/".concat(userId, "/prestacion/").concat(prestacionId, "/asistencial/episodios/rehabilitacion/").concat(episodioId))];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        }); };
        //llamada a episodio Images por id
        _this.getEpisodeImagesbyId = function (userId, prestacionId, episodioId) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.axios.get("/api/v2/user/".concat(userId, "/prestacion/").concat(prestacionId, "/asistencial/episodios/imagen/").concat(episodioId))];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        }); };
        //llamada a Imagen por id
        // getImagesbyId = async (id: string): Promise<any> => {
        //   return await this.axios.get(`/api/v2/obtenerImagenEpisodioImagen/${id}`);
        // };
        _this.getImagesbyId = function (id) { return __awaiter(_this, void 0, void 0, function () {
            var response, contentType, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.axios.get("/api/v2/obtenerImagenEpisodioImagen/".concat(id), {
                                responseType: 'arraybuffer',
                                headers: {
                                    'Accept': 'image/jpeg'
                                }
                            })];
                    case 1:
                        response = _a.sent();
                        contentType = response.headers['content-type'];
                        if (contentType && contentType.startsWith('image/jpeg')) {
                            return [2 /*return*/, response.data];
                        }
                        else {
                            throw new Error('La respuesta no es una imagen JPEG.');
                        }
                        return [3 /*break*/, 3];
                    case 2:
                        error_1 = _a.sent();
                        throw error_1;
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        //llamada a episodio Rehabilitación por id
        _this.getEpisodeRehabilitationById = function (userId, prestacionId, episodioId, sesionId) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.axios.get("/api/v2/user/".concat(userId, "/prestacion/").concat(prestacionId, "/asistencial/episodios/rehabilitacion/").concat(episodioId, "/sesion/").concat(sesionId))];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        }); };
        // Visit = Consulta
        _this.getVisit = function (userId, prestacionId, episodioId) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.axios.get("/api/v2/user/".concat(userId, "/prestacion/").concat(prestacionId, "/asistencial/episodios/ambulatorio/").concat(episodioId))];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        }); };
        // Urgencias
        _this.getEmergencies = function (userId, prestacionId, episodioId) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.axios.get("/api/v2/user/".concat(userId, "/prestacion/").concat(prestacionId, "/asistencial/episodios/urgencia/").concat(episodioId))];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        }); };
        // Imagenes
        _this.getImages = function (userId, prestacionId, episodioId) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.axios.get("/api/v2/user/".concat(userId, "/prestacion/").concat(prestacionId, "/asistencial/episodios/imagen/").concat(episodioId))];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        }); };
        // Centro Externo
        _this.getExternalCenter = function (userId, prestacionId, episodioId) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.axios.get("/api/v2/user/".concat(userId, "/prestacion/").concat(prestacionId, "/asistencial/episodios/centroexterno/").concat(episodioId))];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        }); };
        return _this;
    }
    return RecordSheetsService;
}(recordSheets_config_1.default));
exports.default = RecordSheetsService;
